import { render } from "./ProductCardPrice.vue?vue&type=template&id=1710a18e&scoped=true"
import script from "./ProductCardPrice.vue?vue&type=script&lang=js"
export * from "./ProductCardPrice.vue?vue&type=script&lang=js"

import "./ProductCardPrice.vue?vue&type=style&index=0&id=1710a18e&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1710a18e"]])

export default __exports__